import { render } from "./SimpleForm.vue?vue&type=template&id=3ce4506c"
import script from "./SimpleForm.vue?vue&type=script&lang=js"
export * from "./SimpleForm.vue?vue&type=script&lang=js"

import "./SimpleForm.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script